import { useEffect, useRef, useState, useContext } from "react";
import { AppContext } from "../../context/AppContext";
import axios from "axios";

const Advertise = ({ slot, width, wrapperWidth }) => {
  const adRef = useRef(null);
  const [isFilled, setIsFilled] = useState(true);
  const { pageRefresh, baseUrl, token, setPageRefreshCount } =
    useContext(AppContext);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    try {
      if (window.adsbygoogle && adRef.current) {
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {
          //console.error("AdSense error:", e);
        }
      }
    } catch (err) {
      console.error("AdSense error:", err);
    }
    // const timer = setTimeout(() => {
    //   if (adRef.current && adRef.current.getAttribute("data-ad-status") === "unfilled") {
    //     setIsFilled(false);
    //   }
    // }, 3000); // wait 3s before checking

    // return () => clearTimeout(timer);
    const fetchAdvertise = async () => {
      try {
        const res = await axios.get(`${baseUrl}/get-advertise`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (res.data) {
          if (res.data.advertise[0].adv_disable) {
            setPageRefreshCount(3);
          }
        }
      } catch (err) {
        console.error("Error fetching advertise:", err);
      }
    };

    fetchAdvertise();
  }, []);

  return (
    <div
      style={{
        textAlign: "center",
        margin: "0.5px 0",
        height: "800px !important",
        width: wrapperWidth,
      }}
    >
      {pageRefresh == 0 ? (
        <ins
          ref={adRef}
          className="adsbygoogle"
          style={{
            display: "block",
            width: width ? width : "160px",
            height: "280px",
          }}
          data-ad-client="ca-pub-7616427419210158"
          data-ad-slot={slot}
          data-ad-format="auto"
          data-full-width-responsive="true"
          data-adtest="on"
        ></ins>
      ) : (
        // ✅ Fallback placeholder
        <div
          style={{
            width: "100%",
            height: "250px",
            backgroundColor: "#e0e0e0",
            color: "#666",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "14px",
            border: "1px dashed #999",
            marginTop: "30px",
          }}
        >
          Ad Space (Placeholder)
        </div>
      )}
    </div>
  );
};

export default Advertise;
